import { FormControl, FormHelperText, FormLabel, MenuItem, Stack, TextField } from '@mui/material';
import React, { ChangeEvent } from 'react';
interface FormSelectProps {
  name?: string;
  label: string;
  value?: string | null;
  type?: string;
  required?: boolean;
  helperText?: string;
  hidden?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  items?: Array<{ value: string | number; label: string }>;
  variant?: 'filled' | 'outlined' | 'standard';
  disabled?: boolean;
  direction?: 'row' | 'column';
  split?: number;
  renderValue?: (value: string | null | undefined) => React.ReactNode;
}

export function FormSelect(props: FormSelectProps) {
  const { direction = 'column', hidden, variant = 'standard', split = 0.5 } = props;

  return (
    <FormControl required={props.required} hiddenLabel={hidden} fullWidth variant={variant}>
      <Stack direction={direction} spacing={0} useFlexGap>
        <FormLabel hidden={hidden} sx={{ width: direction === 'row' ? split : undefined }}>
          {props.label}
        </FormLabel>

        <Stack direction={'column'} spacing={1} useFlexGap width={direction === 'row' ? 1 - split : 1} flexGrow={1}>
          <TextField
            select
            name={props.name}
            value={props.value ?? undefined}
            onChange={props.onChange}
            variant={variant}
            disabled={props.disabled}
          >
            {props.items?.map((item, idx) => (
              <MenuItem key={idx} value={item.value}>
                {item.label}
              </MenuItem>
            ))}
          </TextField>
          {props.helperText && <FormHelperText>{props.helperText}</FormHelperText>}
        </Stack>
      </Stack>
    </FormControl>
  );
}
